/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Mobile_Converting_PercentInputs */

const en_mobile_converting_percent = /** @type {(inputs: Mobile_Converting_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.percent}% converted`)
};

const es_mobile_converting_percent = /** @type {(inputs: Mobile_Converting_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.percent}% convertido`)
};

/**
* | output |
* | --- |
* | "{percent}% converted" |
*
* @param {Mobile_Converting_PercentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_converting_percent = /** @type {((inputs: Mobile_Converting_PercentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Converting_PercentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_converting_percent(inputs)
	return en_mobile_converting_percent(inputs)
});